// removed by extract-text-webpack-plugin
module.exports = {"inputGroup":"_1KVWPwjnUtqDmEVCugx9Ur","label":"_1iSNQez-0puwyytpvbqzHx"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/01-molecules/form-elements/select-list.scss
// module id = 87
// module chunks = 0